module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"no_video_data":"已登记的视频不存在。","no_video_reviews":"没有视频评论。"}}')
  delete Component.options._Ctor
}
